module.exports = __webpack_public_path__ + "img/elective.79c7850a.svg";